import React, { useContext, useMemo, useRef } from "react";
import { Link } from "react-router-dom";
import { MainContext } from "../../main-context";
import Spinner from "../helpers/Spinner";
import offline_css from "../offline.module.css";
import InspectionList from "./InspectionList";
import { getQuarter } from "../../lib/calculation";

export default function Maintenance({
  setSelectedEquipmentType,
  setSelectedTerminal,
  setSelectedAirline,
  inspectionFilter,
  inspection_types,
  existsInDatabase,
  selectedTerminal,
  selectedEquipmentType,
}) {
  const main_context = useContext(MainContext);
  const quarter = useRef(getQuarter(new Date()));
  const date = useRef(new Date());

  const maintenaceReady = useMemo(() => {
    return (
      !!main_context.inspections &&
      inspection_types.current.some((x) => main_context.inspections[x])
    );
  }, [inspection_types, main_context.inspections]);

  const fullInspections = useMemo(() => {
    let all = [];
    if (maintenaceReady) {
      for (const type of inspection_types.current) {
        all = all.concat(main_context.inspections[type] ?? []);
      }
    }
    return all;
  }, [inspection_types, main_context.inspections, maintenaceReady]);

  const getTerminals = useMemo(() => {
    const terminals = {};
    if (maintenaceReady) {
      for (const inspection of fullInspections) {
        if (inspection.terminal) {
          terminals[inspection.terminal] = true;
        }
      }
    }

    return Object.keys(terminals);
  }, [fullInspections, maintenaceReady]);

  const getEquipment = useMemo(() => {
    const equipment = {};
    if (maintenaceReady) {
      for (const inspection of fullInspections) {
        if (inspection.equipmentTypeId) {
          equipment[inspection.equipmentTypeId] = true;
        }
      }
    }

    return Object.keys(equipment);
  }, [fullInspections, maintenaceReady]);

  return (
    <div>
      <MainContext.Consumer>
        {({ inspections, equipmentTypes }) => (
          <>
            <Link to="maintenance/remaining" className="btn btn-xs btn-default">
              {" "}
              Return To Service Inspections
            </Link>
            <h2 className="text-center">
              Click on equipment to start inspection
            </h2>
            {!inspections && (
              <h1 className="text-center">
                Loading...
                <Spinner
                  waitfor={inspections}
                  className={offline_css["daily-spinner"]}
                ></Spinner>
              </h1>
            )}
            {maintenaceReady && (
              <div>
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                  }}
                >
                  {!!getEquipment.length && (
                    <div
                      className="col-xs-4"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <select
                        style={{
                          maxWidth: "200px",
                        }}
                        className="form-control"
                        onChange={(event) =>
                          setSelectedEquipmentType(event.target.value)
                        }
                        value={selectedEquipmentType}
                      >
                        <option value="">Equipment Types</option>
                        {getEquipment.map((elem) => (
                          <option key={elem} value={elem}>
                            {equipmentTypes[elem]}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {!!getTerminals.length && (
                    <div
                      className="col-xs-4"
                      style={{
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <select
                        style={{
                          maxWidth: "200px",
                        }}
                        className="form-control"
                        onChange={(event) =>
                          setSelectedTerminal(event.target.value)
                        }
                        value={selectedTerminal}
                      >
                        <option value="">Filter</option>
                        {getTerminals.map((elem) => (
                          <option key={elem} value={elem}>
                            {elem}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div
                    className={"col-xs-12 " + offline_css["maintenance-list"]}
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      marginTop: "20px",
                    }}
                  >
                    <div className="col-md-6 col-lg-3 col-xs-12">
                      <h3
                        className={`text-center ${offline_css["maintenance-header"]}`}
                      >
                        <span>
                          {" "}
                          {date.current.toLocaleString("en", {
                            month: "long",
                          })}
                        </span>
                        <br />
                        Inspections Due
                      </h3>
                      <InspectionList
                        existsInDatabase={existsInDatabase}
                        setSelectedAirline={setSelectedAirline}
                        inspection-airlines={inspections.airlines}
                        inspectionFilter={inspectionFilter}
                        type={"monthly"}
                        offline_css={offline_css}
                        showType={true}
                      ></InspectionList>
                    </div>
                    <div className="col-md-6 col-lg-3 col-xs-12">
                      <h3
                        className={`text-center ${offline_css["maintenance-header"]}`}
                      >
                        {" "}
                        <span>Q{quarter.current} </span>
                        <br />
                        Quarterly Inspections
                      </h3>
                      <InspectionList
                        existsInDatabase={existsInDatabase}
                        setSelectedAirline={setSelectedAirline}
                        inspection-airlines={inspections.airlines}
                        inspectionFilter={inspectionFilter}
                        type={"quarterly"}
                        offline_css={offline_css}
                        showType={true}
                      ></InspectionList>
                    </div>
                    <div className="col-md-6 col-lg-3 col-xs-12">
                      <h3
                        className={`text-center ${offline_css["maintenance-header"]}`}
                      >
                        {" "}
                        <span>{date.current.getFullYear()} </span>
                        <br />
                        Semi-Annual &amp; Annual
                      </h3>
                      <InspectionList
                        existsInDatabase={existsInDatabase}
                        setSelectedAirline={setSelectedAirline}
                        inspection-airlines={inspections.airlines}
                        inspectionFilter={inspectionFilter}
                        type={"annual-semi-annual"}
                        offline_css={offline_css}
                        showType={true}
                      ></InspectionList>
                    </div>
                    <div className="col-md-6 col-lg-3 col-xs-12">
                      <h3
                        className={`text-center ${offline_css["maintenance-header"]}`}
                      >
                        {" "}
                        <span>{date.current.getFullYear()}</span>
                        <br />
                        Calibrations
                      </h3>
                      <InspectionList
                        existsInDatabase={existsInDatabase}
                        setSelectedAirline={setSelectedAirline}
                        inspection-airlines={inspections.airlines}
                        inspectionFilter={inspectionFilter}
                        type={"calibrations"}
                        offline_css={offline_css}
                        showType={true}
                      ></InspectionList>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </MainContext.Consumer>
    </div>
  );
}
